export const aanmeldingenState = {

  isPending: false,

  lastUpdated: null,
  dag_id: null,
  is_today: false,
  diensten: [],
  n_instructors: 0,
  registration_lists: [],
  messages: [],
  notities: {},
  bevoegdheden: {},
  aanmeldingen: [],
  sleep_vliegers: [],
  kisten: [],
  rollen: [],
  topmeteo: {},
}
